import { FC, PropsWithChildren } from 'react';

import Cookies from 'bloko/common/Cookies';

import GridContainer, { GridRow, GridColumn } from 'src/components/Grid';

import styles from 'src/components/Grid/grid.less';

const COLUMN_COUNT_M = 14;
const COLUMN_COUNT_L = 16;

const GridDebug: FC<PropsWithChildren> = () => {
    const gridDebug = typeof window === 'undefined' ? false : Cookies.get('statportalGridDebug');

    if (!gridDebug) {
        return null;
    }

    return (
        <div className={styles.gridDebug}>
            <GridContainer>
                <GridRow>
                    {[...new Array<unknown>(COLUMN_COUNT_L)].map((_, index) => (
                        <GridColumn key={index} m={index < COLUMN_COUNT_M ? '1' : '0'} l="1">
                            <div className={styles.gridDebugColumn} />
                        </GridColumn>
                    ))}
                </GridRow>
            </GridContainer>
        </div>
    );
};

export default GridDebug;
